import clsx from 'clsx';
import React from 'react';
import { TW_RING } from '../../../../../domain/websiteDomain';
import {
  ClassMinimalFragment,
  FetchSessionsMinimalQueryVariables,
} from '../../../../../typescript/generated/codegen';
import { UniqueType } from './filtersSideModal';

interface TypesProps {
  filters: FetchSessionsMinimalQueryVariables;
  setFilters: (filters: FetchSessionsMinimalQueryVariables) => void;
  uniqueTypes: UniqueType[];
  allResults: ClassMinimalFragment[];
}

const Types: React.FC<TypesProps> = ({
  filters,
  setFilters,
  uniqueTypes,
  allResults,
}) => {
  const { classifications, types } = filters;

  const handleSetTypes = (type: string) => {
    if (!filters.types) {
      setFilters({ ...filters, types: [type] });
    } else if (Array.isArray(filters.types)) {
      const updatedTypes = filters.types?.includes(type)
        ? filters.types?.filter(t => t !== type)
        : [...filters.types, type];

      setFilters({
        ...filters,
        types: updatedTypes.length > 0 ? updatedTypes : undefined,
      });
    }
  };

  if (!classifications || classifications?.length === 0) return null;

  const displayedTypes = uniqueTypes
    .filter(
      item =>
        classifications.includes(item.classification) &&
        allResults.some(result => result.type === item.type)
    )
    .sort((a, b) => {
      if (a.type < b.type) return -1;
      if (a.type > b.type) return 1;
      return 0;
    });

  if (displayedTypes.length < 2) return null;

  return (
    <ul className="pt-32px space-y-24px">
      {displayedTypes.map(item => {
        const isSelected = !!types?.includes(item.type);
        const isSelectable = allResults.some(
          result => result.type === item.type
        );

        const id = `checkbox-${item.classification}-${item.type}`;

        return (
          <li
            key={`${item.classification}-${item.type}`}
            className={clsx('flex flex-row items-center justify-between')}
          >
            <label
              htmlFor={id}
              className={clsx(
                isSelectable ? 'cursor-pointer' : 'text-gray-300'
              )}
            >
              {item.type}
            </label>
            <input
              id={id}
              type="checkbox"
              className={clsx(
                'text-accent-light form-checkbox h-24px w-24px rounded-sm border-accent-light',
                isSelectable && 'cursor-pointer',
                TW_RING
              )}
              disabled={!isSelectable}
              checked={isSelected}
              onChange={() => isSelectable && handleSetTypes(item.type)}
            />
          </li>
        );
      })}
    </ul>
  );
};

export default Types;
